import { ExperienceFe } from "@intelligems/ig-types/fe-only/experiences";
import { ExperienceListDto } from "@intelligems/ig-types/dtos/experiences-list";
import { AppDispatch } from "@src/store";
import { getDefaultHiddenEndTime } from "@src/store/helpers";
import { updateDashboardFilter } from "@src/store/slices/dashboardFilters";
import { Experience } from "@src/store/slices/experiences/types";
import { openDialog } from "@src/store/slices/global";

export const isRolloutEnabled = (experience: Experience) => {
  return (
    experience.status !== "pending" &&
    !experience.testTypes.hasTestShipping &&
    (!experience.testTypes.hasTestPricing ||
      (experience.status !== "started" &&
        experience.status !== "ended" &&
        experience.testTypes.hasTestPricing))
  );
};

export const renderRolloutButton = (
  tabClicked: string,
  analyticsDataNotAvailable: boolean,
  isDataLoading: number,
  experience: Experience,
  location: "Menu" | "ActionButtons"
) => {
  const rolloutEnabled = isRolloutEnabled(experience);

  if (location === "ActionButtons" && tabClicked === "analytics") {
    if (analyticsDataNotAvailable === undefined || isDataLoading !== 0) {
      return false;
    }
    return !analyticsDataNotAvailable && rolloutEnabled;
  } else if (location === "Menu" && tabClicked !== "analytics") {
    return rolloutEnabled;
  }

  return false;
};

export const onRolloutClick = (
  experience: Experience,
  storeCurrencyConfig,
  dispatch: AppDispatch
) => {
  dispatch(
    updateDashboardFilter({
      key: "hiddenEndTime",
      value: getDefaultHiddenEndTime(experience),
    })
  );

  if (experience.testTypes.hasTestPricing) {
    onPriceTestAction(
      experience,
      "end",
      storeCurrencyConfig?.value?.code ?? "USD",
      dispatch
    );
  } else {
    dispatch(openDialog("rollouts"));
  }
};

/**
 * A price test priced in a currency other than the store's default. Gates both
 * the Market price-updater flows and the Shopify Markets export option, so the
 * two cannot drift apart.
 */
export const isNonDefaultCurrencyPriceTest = (
  experienceCurrencyCode: string | null | undefined,
  storeCurrencyConfigCode: string
) =>
  Boolean(experienceCurrencyCode) &&
  storeCurrencyConfigCode !== experienceCurrencyCode;

export const onPriceTestAction = (
  experience:
    | Pick<ExperienceFe, "status" | "experienceActions" | "currency">
    | Pick<ExperienceListDto, "status" | "experienceActions" | "currency">,
  action: "start" | "pause" | "end" | "reset",
  storeCurrencyConfigCode: string,
  dispatch: AppDispatch
) => {
  if (
    isNonDefaultCurrencyPriceTest(
      experience.currency?.code,
      storeCurrencyConfigCode
    )
  ) {
    if (action === "start") {
      dispatch(openDialog("marketPriceUpdaterStart"));
    } else {
      dispatch(
        updateDashboardFilter({
          key: "hiddenEndTime",
          value: getDefaultHiddenEndTime(experience),
        })
      );
      dispatch(openDialog({ dialog: "marketPriceUpdater", props: { action } }));
    }
  } else {
    if (action === "start") {
      dispatch(openDialog("priceUpdaterStart"));
    } else {
      dispatch(
        updateDashboardFilter({
          key: "hiddenEndTime",
          value: getDefaultHiddenEndTime(experience),
        })
      );
      dispatch(openDialog({ dialog: "priceUpdater", props: { action } }));
    }
  }
};
